// Lumi Plus page entry. The marketing content is static in plus.html (great for
// SEO); this only mounts the sign-up sidebar island and fills the footer year.
import '@lumi/shared/design-tokens.css';
import './styles.css';
import { mountPlusSignup } from './ui/plus-signup.js';

const signup = document.getElementById('plus-signup');
if (signup) mountPlusSignup(signup);

const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());
